import ImportAccountIcon from './ImportAccountIcon'

export default ImportAccountIcon
